import axios from "axios";

const confirmEmail = async (
  userId: string,
  code: string,
  changedEmail?: string,
) => {
  const apiUrl = import.meta.env.VITE_API_URL;

  const params = new URLSearchParams({
    userId,
    code,
    ...(changedEmail && { changedEmail }),
  });

  const response = await axios.get(
    `${apiUrl}/confirmEmail?${params.toString()}`,
    {
      withCredentials: true,
    },
  );

  if (response.status === 200) {
    return true;
  } else {
    throw new Error("Email confirmation failed");
  }
};

export default confirmEmail;

